import createStore from 'zustand';
import isEqual from 'lodash.isequal';
import createVanilla from 'zustand/vanilla';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

// TODO: make this a better type
var filterState = function filterState(state, options) {
  var excluded = (options == null ? void 0 : options.exclude) || (options == null ? void 0 : options.omit);
  var included = options == null ? void 0 : options.include;
  var filteredState = {};
  Object.keys(state).forEach(function (key) {
    if (!(excluded && excluded.includes(key)) && (!included || included.includes(key))) {
      filteredState[key] = state[key];
    }
  });
  return filteredState;
};

var handleStoreUpdates = function handleStoreUpdates(get, action) {
  var _get = get(),
      prevStates = _get.prevStates,
      futureStates = _get.futureStates,
      setStore = _get.setStore,
      getStore = _get.getStore,
      options = _get.options;

  var isUndo = action === 'undo';
  var currentActionStates = isUndo ? prevStates : futureStates;
  var otherActionStates = isUndo ? futureStates : prevStates;
  var limit = options == null ? void 0 : options.historyDepthLimit;

  if (currentActionStates.length > 0) {
    // check history limit
    if (limit && otherActionStates.length >= limit) {
      // pop front
      otherActionStates.shift();
    }

    otherActionStates.push(filterState(getStore(), options));
    var currentStoreState = currentActionStates.pop();
    setStore(currentStoreState);
  }
}; // factory to create undoStore. contains memory about past and future states and has methods to traverse states


var createUndoStore = function createUndoStore() {
  return createVanilla(function (set, get) {
    return {
      prevStates: [],
      futureStates: [],
      isUndoHistoryEnabled: true,
      undo: function undo() {
        var _get2 = get(),
            coolOffTimer = _get2.coolOffTimer; // Clear cool off if user clicks "undo" during cool-off period


        if (coolOffTimer) clearTimeout(coolOffTimer);
        set({
          isCoolingOff: false
        });
        handleStoreUpdates(get, 'undo');
      },
      redo: function redo() {
        handleStoreUpdates(get, 'redo');
      },
      clear: function clear() {
        set({
          prevStates: [],
          futureStates: []
        });
        get().setStore();
      },
      setIsUndoHistoryEnabled: function setIsUndoHistoryEnabled(isEnabled) {
        var _get3 = get(),
            prevStates = _get3.prevStates,
            getStore = _get3.getStore,
            options = _get3.options;

        var currState = filterState(getStore(), options);
        set({
          isUndoHistoryEnabled: isEnabled,
          prevStates: isEnabled ? prevStates : [].concat(prevStates, [currState])
        });
      },
      setStore: function setStore() {},
      getStore: function getStore() {},
      options: {},
      forceUpdate: function forceUpdate() {}
    };
  });
};

var undoMiddleware = function undoMiddleware(config, options) {
  return function (set, get, api) {
    var undoStore = createUndoStore();
    var getState = undoStore.getState,
        setState = undoStore.setState;
    return config(function (args) {
      /* TODO: const, should call this function and inject the values once, but it does
      it on every action call currently. */
      var _getState = getState(),
          undo = _getState.undo,
          clear = _getState.clear,
          redo = _getState.redo,
          setIsUndoHistoryEnabled = _getState.setIsUndoHistoryEnabled,
          isUndoHistoryEnabled = _getState.isUndoHistoryEnabled,
          isCoolingOff = _getState.isCoolingOff,
          coolOffTimer = _getState.coolOffTimer; // inject helper functions to user defined store.


      set({
        undo: undo,
        clear: clear,
        redo: redo,
        getState: getState,
        setIsUndoHistoryEnabled: setIsUndoHistoryEnabled
      }); // Get the last state before updating state

      var lastState = filterState(_extends({}, get()), options);
      set(args); // Get the current state after updating state

      var currState = filterState(_extends({}, get()), options); // Only store changes if state isn't equal (or option has been set)

      var shouldStoreChange = isUndoHistoryEnabled && (!isEqual(lastState, currState) || (options == null ? void 0 : options.allowUnchanged));
      var limit = options == null ? void 0 : options.historyDepthLimit;

      if (shouldStoreChange) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        coolOffTimer && clearTimeout(coolOffTimer);

        if (!isCoolingOff) {
          var _getState2 = getState(),
              prevStates = _getState2.prevStates;

          if (limit && prevStates.length >= limit) {
            // pop front
            prevStates.shift();
          }

          setState({
            prevStates: [].concat(prevStates, [lastState]),
            futureStates: [],
            options: options,
            setStore: set,
            getStore: get
          });
        }

        setState({
          isCoolingOff: true,
          coolOffTimer: window.setTimeout(function () {
            setState({
              isCoolingOff: false
            });
          }, options == null ? void 0 : options.coolOffDurationMs)
        });
      }
    }, get, api);
  };
};

var create = function create(config, options) {
  return createStore(undoMiddleware(config, options));
};

export default create;
export { create, undoMiddleware };
//# sourceMappingURL=zundo.esm.js.map
